import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { Mpppay, VirtualNin, getAggregators } from "../../redux/selfService/selfServiceSlice";
import LoadingSpinner from "../../components/LoadingSpinner";
import PageName from "../../components/PageName";
import SuccessModal from "../../components/SuccessModal";
import Card from "../../components/Base/Card";
import ErrorViewer from "../../components/ErrorViewer";
import Required from "../../components/Required";
import TimeOutActivityLayout from "../auth/inactivity-timeout-v2";

const paymentserviceValues = ["Recapture", "KYC", "PIN Generation"];
const recurringpaymentValues = ["One Time Payment", "Recurring Payment"];

const SelfContributionPage = () => {
  const dispatch = useAppDispatch();
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const { allBanks, isLoading } = useAppSelector((state) => state?.selfService);
  const [aggregators, setAggregators] = useState<any>();
  const [linkUrl, setLinkUrl] = useState("");


  const validationSchema = Yup.object().shape({
    amount: Yup.string().required("Please enter the amount"),
    recurringpayment: Yup.string().required("Please select Recurring Payment"),
    paymentservice: Yup.string().required("Please select Payment Service"),
  });

  const defaultValues = {
    amount: "",
    paymentservice: "",
    recurringpayment: "",
  };

  const { handleSubmit, register, setValue, reset, formState: { errors }, } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues
  });

  useEffect(() => {
    dispatch(getAggregators()).then((res) => {
      if (res.type === "selfService/aggregator/fulfilled" && res.payload !== undefined) {
        setAggregators(res.payload);
      }
    });
  }, []);


  const openLinkInNewWindow = () => {
    if (linkUrl) {
      window.open(linkUrl, "_blank");
    }
  };
  const onSubmit = (values: any) => {
    const recurringPayment = values.recurringpayment === "1" ? true : false;

    const formattedValues = {
      amount: values.amount,
      recurringPayment,
      paymentId: parseInt( values.paymentservice),
    };

    dispatch(Mpppay(formattedValues)).then((res) => {
      if (res?.type === 'selfService/mpppay/fulfilled') {
        setSuccessMessage(res?.payload?.statusMessage);


      // Set the link URL from the response payload
      const linkUrl = res?.payload?.responseObject?.data?.link;

      if (linkUrl) {
        // Open the link in a new window
        window.open(linkUrl, "_blank");
      }
        
      // Set the link URL from the response payload
     // setLinkUrl(res?.payload?.responseObject?.data?.link);

        reset(defaultValues);
      }
    });
  };

  return (
    <TimeOutActivityLayout>
    <div className="statement-page">
      <PageName pageName={"Self Contribution"} />
      <div>
        <SuccessModal
          showModal={showSuccessModal}
          onClose={() => setShowSuccessModal(false)}
          note={successMessage}
        />
        <div className="mx-4">
          <div className="h1 text-grayscaleBody">Self Contribution</div>
          <div className="w-full">
            <Card className="mb-8 bg-grayscaleBG">
              <div className="section-card">
                <div className="pt-12 whitespace-pre mr-6">
                  {/* Self Contribution */}
                </div>
                <div className="w-full">
                  <div className="mx-auto max-w-[400px]">
                    <div className="form__group">
                      <label htmlFor="vnin" className="form__label">
                        Amount <Required />
                      </label>
                      {/* <input
                        placeholder="Amount"
                        type="text"
                        id="amount"
                        className="form__input"
                        {...register("amount")}
                      /> */}

<input
  placeholder="Amount"
  type="number" // Use type "number" for numeric input
  id="amount"
  className="form__input"
  {...register("amount")}
  step="0.01" // Set the step to allow decimal values, adjust as needed
/>


                      {errors.amount && (
                        <ErrorViewer message={errors.amount.message as string} />
                      )}
                    </div>

                    <div className="form__group">
                      <label htmlFor="recurringpayment" className="form__label">
                        Recurring Payment <Required />
                      </label>
                      <select
                        id="recurringpayment"
                        defaultValue=""
                        className="form__select"
                        {...register("recurringpayment")}
                      >
                        <option value="" disabled>Select Recurring Payment</option>
                        {recurringpaymentValues.map((recurringpayment, index) => (
                          <option key={index} value={index}>
                            {recurringpayment}
                          </option>
                        ))}
                      </select>
                      {errors.recurringpayment && (
                        <ErrorViewer message={errors.recurringpayment.message as string} />
                      )}
                    </div>

                    <div className="form__group">
                      <label htmlFor="paymentservice" className="form__label">
                        Payment Service <Required />
                      </label>
                      <select
                        id="paymentservice"
                        className="form__select"
                        {...register("paymentservice")}
                      >
                        <option value="" disabled>Select Service</option>
                        {aggregators?.map((aggregator) => (
                          <option key={aggregator.id} value={aggregator.id.toString()}>
                            {aggregator.name}
                          </option>
                        ))}
                      </select>
                      {errors.paymentservice && (
                        <ErrorViewer message={errors.paymentservice.message as string} />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </Card>
            <div className="flex justify-end text-primary mb-40">
              <button
                className="btn btn-primary font-semibold mr-4"
                onClick={handleSubmit(onSubmit)}
                disabled={isLoading}
              >
                {isLoading ? <LoadingSpinner /> : "Continue"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    </TimeOutActivityLayout>
  );
};

export default SelfContributionPage;
